export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const formatterWithDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const formatCurrency = (
  dollarValue?: number | string,
  useDecimals = false
) => {
  if (dollarValue === undefined) {
    return '';
  }
  const dollars =
    typeof dollarValue === 'number'
      ? dollarValue
      : Number(Number(dollarValue).toFixed(2));

  if (useDecimals) return formatterWithDecimals.format(dollars);
  return formatter.format(dollars);
};
